export default __webpack_public_path__ + "static/media/green-check.3d0f9213.jpg";